/* !
 * jQuery index v1.0.0
 * Copyright 2019, Connecty Inc.
 */
(function($, RIKEN){
	const a = 'is-active';
	const v = 'is-visible';
	const f = 'is-fixed';
	const $path = location.pathname;

	let $head;
	let $unit = '';
	if($path.indexOf('/en/') !== -1) { // 英語
		$head = '/en/ir/topics/';
		let latestY = $('.rt_bn_latest_news .rt_year').text();
		if($path === $head || $path === $head +'index.html') {
			location.href = $path.replace('index.html', '') + latestY + '/';
		}
	} else { // 日本語
		$unit = '年';
		if($path.indexOf('ir') !== -1) {
			$head = '/corporate/ir/topics/';
		} else {
			$head = '/news/';
		}
	}

	// ===============================================================
	// <ニュース一覧>年号セレクト
	const selectYear = () => {
		if($('.js-select-year').length) {
			const $selectY = $('.js-select-year');
			const $options = $('.mod-select01-options');

			// 最新年、最古年
			let latestY = $('.rt_bn_latest_news .rt_year').text();
			let oldestY = $('.rt_bn_earliest_news .rt_year').text();
			// 年号セレクトボックス生成
			for(let i = latestY; i > oldestY-1; i--) {
				if($path.indexOf(i) !== -1) {
					$('.mod-select01-selected .__year').text(i +$unit);
					$options.append('<li class="mod-select01-options-item is-current"><span class="__year">'+ i +'</span>'+ $unit +'</li>');
				} else {
					$options.append('<li class="mod-select01-options-item"><span class="__year">'+ i +'</span>'+ $unit +'</li>');
				}
			}

			// クリック時
			$selectY.on('click', (e) => {
				$options.addClass(a);
			});
			document.addEventListener('click', (e) => {
				if(!e.target.closest('.js-select-year')) {
					$options.removeClass(a);
				}
			});
		}
	}

	// <ニュース一覧>年号セレクト変更時
	const selectYearChange = () => {
		if($('.js-select-year').length) {
			let selectCat = '';
			if($('.js-newsCategory').length) {
				selectCat = $('.js-newsCategory.is-active').attr('data-cat');
			}
			$('.mod-select01-options-item').on('click', (e) => {
				let $this = $(e.currentTarget);
				let thisY  = $this.find('.__year').text();
				if(selectCat == 'all' || selectCat == '') {
					location.href = $head + thisY +'/';
				} else {
					location.href = $head + thisY +'/'+ selectCat +'/';
				}
			});
		};
	};

	// <ニュース一覧>ニュースカテゴリ
	const newsCategoryTab = () => {
		if($('.js-newsCategory').length) {
			let latestY = $('.rt_bn_latest_news .rt_year').text();
			$('.js-newsCategory').each((idx,ele) => {
				let thisCat = $(ele).attr('data-cat');
				let $href;
				if(thisCat === 'all') {
					if($('.mod-select01-options-item.is-current').length) {
						$href = $head + $('.mod-select01-options-item.is-current .__year').text() +'/';
					} else {
						$href = $head + latestY +'/';
					}
				} else {
					if($('.mod-select01-options-item.is-current').length) {
						$href = $head + $('.mod-select01-options-item.is-current .__year').text() +'/'+ thisCat +'/';
					} else {
						$href = $head + latestY +'/'+ thisCat +'/';
					}
				}
				$(ele).attr('href', $href);

				if($path.indexOf(thisCat) !== -1) {
					$('.js-newsCategory').removeClass(a);
					$(ele).addClass(a);
				}
			});

			if($('.js-newsCategory.is-active').length && !$('.mod-select01-options-item.is-current').length) {
				let thisCat = $('.js-newsCategory.is-active').attr('data-cat');
				if(thisCat == 'all') {
					location.href = $head + latestY +'/';
				} else {
					location.href = $head + latestY +'/'+ thisCat +'/';
				}
			}
		}
	}

	// <ニュース一覧>ページ下部「年別」
	const createNewsYearList = () => {
		if($('.js-bottom-yearList').length) {
			// 最新年、最古年
			let latestY = $('.rt_bn_latest_news .rt_year').text();
			let oldestY = $('.rt_bn_earliest_news .rt_year').text();
			// 選択中カテゴリ取得
			let thisCat = '';
			if($('.js-newsCategory.is-active').length) {
				let activeCat = $('.js-newsCategory.is-active').attr('data-cat');
				if(activeCat !== 'all') {
					thisCat =  activeCat + '/';
				}
			}

			for(let i = latestY; i > oldestY-1; i--) {
				if($path.indexOf(i) !== -1) {
					$('.js-bottom-yearList').append(`<li class="news-idx-years-item">
						<a href="${$head}${i}/" class="news-idx-years-item-a is-active">
							<span class="__txt">${i}</span>
							<svg class="icon"><use xlink:href="/common/svg/sprite.svg#arrow_right"></use></svg>
						</a>
					</li>`);
				} else {
					$('.js-bottom-yearList').append(`<li class="news-idx-years-item">
						<a href="${$head}${i}/" class="news-idx-years-item-a">
							<span class="__txt">${i}</span>
							<svg class="icon"><use xlink:href="/common/svg/sprite.svg#arrow_right"></use></svg>
						</a>
					</li>`);
				}
			};
		}
	};

	// ==============================================================================
	if($('.js-newsListWrap').length) {
		if($path !== $head && $path !== $head + '/index.html') {
			$('.js-newsListWrap').removeClass('di_none');
		}
	}
	selectYear();
	newsCategoryTab();
	selectYearChange();
	createNewsYearList();

})(window.jQuery, window.RIKEN);
